<template>
  <div class="card mb-3">
    <div class="card-header">
      <h6 class="m-0 font-weight-bold text-primary">Test</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-12 mb-3">
          <div class="px-3">
            <label class="pl-0 m-0 d-flex align-items-center">Status</label>
            <p class="m-0">{{ data.arr_online_test_result.length > 0 ? 'Sudah' : 'Belum' }}</p>
          </div>
        </div>
        <div class="form-group col-12 mb-0">
          <div class="px-3">
            <label class="pl-0 m-0 d-flex align-items-center">Nilai</label>
            <p class="m-0">{{ data.arr_online_test_result.length > 0 ? data.arr_online_test_result[0].score : '-' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"]
}
</script>
